import useSearchFiltersMeta from './useSearchFiltersMeta';
import useSearchResults from './useSearchResults';

/**
 * Current implementation couple the fetch of the all filters meta with the DetailsView open modal.
 */
export const useSearchAllFiltersMeta = () => {
    const resultsWithoutFilters = useSearchResults();

    const samplesAllFiltersMeta = useSearchFiltersMeta({
        filterMetaObj: resultsWithoutFilters.samplesFilterMetaObj,
    });

    const packsAllFiltersMeta = useSearchFiltersMeta({
        filterMetaObj: resultsWithoutFilters.packsFilterMetaObj,
    });

    const {
        samplesTotal: allSamplesTotal,
        samplesLoading,
        samplesCompleted: allSamplesCompleted,
        updateSamplesResult: updateAllSamplesResult,
        updateSamplesLoading: updateAllSamplesLoading,
        updateSamplesError: updateAllSamplesError,
        updateSamplesCompleted: updateAllSamplesCompleted,

        packsTotal,
        packsLoading,
        packsCompleted: allPacksCompleted,
        updatePacksResult: updateAllPacksResult,
        updatePacksLoading: updateAllPacksLoading,
        updatePacksError: updateAllPacksError,
        updatePacksCompleted: updateAllPacksCompleted,
    } = resultsWithoutFilters;

    return {
        allSamplesTotal,
        allSamplesCompleted,
        updateAllSamplesResult,
        updateAllSamplesLoading,
        updateAllSamplesError,
        updateAllSamplesCompleted,
        samplesAllFiltersMeta,

        allPacksTotal: packsTotal,
        allPacksCompleted,
        updateAllPacksResult,
        updateAllPacksLoading,
        updateAllPacksError,
        updateAllPacksCompleted,
        packsAllFiltersMeta,

        filtersLoading: samplesLoading || packsLoading,
    };
};
